export default __webpack_public_path__ + "static/media/G0550.34I-26304_-16172_0.1d18b4e4.jpg";